import { FaIcon } from '@/lib/fa'
import { faClose } from '@fortawesome/pro-light-svg-icons'
import React from 'react'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

const SettingsHeader = ({onClose}) => {
  const { t } = useLocalize()
  return (
    <div className="tw-flex tw-items-center tw-justify-between tw-py-4">
      <div className="tw-ml-4 tw-flex tw-flex-col tw-items-start tw-gap-2">
        <p className="tw-m-0 tw-text-xl tw-font-semibold tw-text-content-base">
         {t('businessTrip.delegation-settings')}
        </p>
        {/* {driverName && (
          <div className="tw-flex tw-items-center tw-gap-1 tw-text-sm">
            <p className="tw-m-0">Dodaj kierowcę</p>
            <div className="tw-flex tw-items-center tw-gap-1 tw-rounded tw-bg-base-300 tw-px-1">
              <FaIcon icon={faIdBadge} className="tw-cursor-pointer" />
              <span>{driverName}</span>
            </div>
            <p className="tw-m-0">do grup.</p>
          </div>
        )} */}
      </div>
      <FaIcon
        icon={faClose}
        className="tw-mr-4 tw-h-5 tw-w-5 tw-cursor-pointer"
        onClick={() => onClose()}
      />
    </div>
  )
}

export default SettingsHeader
